import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#533afd',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: '智栈管理后台',
  pwa: false,
  logo: '/logo.svg',
  iconfontUrl: '',
  token: {
    header: {
      colorBgHeader: '#ffffff',
      colorHeaderTitle: '#061b31',
    },
    sider: {
      colorMenuBackground: '#ffffff',
      colorTextMenuTitle: '#273951',
      colorTextMenu: '#64748d',
      colorTextMenuSelected: '#533afd',
      colorBgMenuItemSelected: 'rgba(83,58,253,0.08)',
      colorTextMenuItemHover: '#061b31',
      colorBgMenuItemHover: 'rgba(83,58,253,0.05)',
    },
    pageContainer: {
      paddingBlockPageContainerContent: 24,
      paddingInlinePageContainerContent: 24,
    },
  },
};

export default Settings;
